import { Component } from '@angular/core';

@Component({
  selector: 'allas-no-esperes-mas',
  imports: [],
  template: `
    <section class="grid grid-cols-1 xl:grid-cols-2 mb-6">
      <div
        class="bg-gray-100 flex flex-col items-center justify-center gap-2 p-4 xl:p-12"
      >
        <h2
          class="text-4xl xl:text-5xl font-extrabold fs-condensed text-appPrimary-500 text-center"
        >
          ¡NO ESPERES MÁS!
        </h2>
        <span class="text-sm xl:text-lg font-light text-center">
          Únete hoy mismo a nuestro programa de beneficios y comienza a ahorrar
          en todas tus compras de repuestos automotrices.
        </span>
        <div class="flex gap-2 mt-2">
          <a
            href="https://play.google.com/store/apps/details?id=com.allasrepuestos.membresia_lealtad&pcampaignid=web_share"
            class="bg-appPrimary-500 text-white text-xs xl:text-sm px-4 py-1 xl:py-2 rounded-md hover:scale-105 transition-transform duration-150"
          >
            AFILIARME AHORA
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.allasrepuestos.membresia_lealtad&pcampaignid=web_share"
            class="border border-appPrimary-500 text-appPrimary-500 px-4 py-1 xl:py-2 rounded-md text-xs xl:text-sm hover:scale-105 transition-transform duration-150"
          >
            DESCARGAR APP
          </a>
        </div>
      </div>
      <div class="bg-appPrimary-500 flex items-end justify-center pt-12">
        <img
          src="/images/services/afiliaciones/recompensas-app-mobile.webp"
          alt="Recompensas de la app de Allas Repuestos"
          class="w-2/3"
        />
      </div>
    </section>
  `,
})
export class NoEsperesMas {}
